import React from "react";
import { Row, Col, Card, ProgressBar, Dropdown } from "react-bootstrap";
import {
  FiMapPin,
  FiDollarSign,
  FiBriefcase,
  FiCalendar,
} from "react-icons/fi";
import { FaApple, FaReact, FaHtml5, FaAndroid } from "react-icons/fa";
import { SiPhp, SiLaravel } from "react-icons/si";

import "bootstrap/dist/css/bootstrap.min.css";

const JobGrid = ({ jobs }) => {
  return (
    <div style={{ backgroundColor: "#f8f9fa" }} className=" mt-2">
      {/* HEADER */}

      {/* GRID */}
      <Row>
        {jobs.map((job, index) => (
          <Col lg={3} md={6} key={job.id || index} className="mb-4">
            <Card className="job-card">
              <Card.Body>
                {/* TOP */}
                <div className="job-top">
                  <div className="job-icon">
                    <img
                      src={job.icon}
                      alt="icon"
                      style={{ width: "20px", height: "20px" }}
                    />
                  </div>
                  <div>
                    <h6>{job.title}</h6>
                    <span>{job.applicants} Applicants</span>
                  </div>
                </div>

                {/* DETAILS */}
                <div className="job-details">
                  <p>
                    <FiMapPin /> {job.location}
                  </p>
                  <p>
                    <FiDollarSign /> {job.salary}
                  </p>
                  <p>
                    <FiBriefcase /> {job.experience}
                  </p>
                </div>

                {/* TAGS */}
                <div className="tags">
                  <span className="tag pink">{job.jobType || "Full Time"}</span>
                  <span className="tag blue">{job.level || "Expert"}</span>
                </div>

                {/* PROGRESS */}
                <ProgressBar
                  now={(job.filled / job.total) * 100}
                  className="progress-custom"
                />
                <small>
                  {job.filled} of {job.total} filled
                </small>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
      <style>
        {`.job-grid-container {
border-radius:6px;
border:1px solid #e5e7eb;
// background:#ffffff;

box-shadow:0 2px 5px rgba(0,0,0,0.05);


}

/* HEADER */
.job-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}

.filters {
  display: flex;
  gap: 10px;
}

.filter-box {
  border: 1px solid #ddd;
  padding: 6px 12px;
  border-radius: 6px;
  background: #fff;
  font-size: 14px;
}

.filter-btn {
  background: #fff !important;
  border: 1px solid #ddd !important;
  color: #333 !important;
  border-radius: 6px !important;
}

/* CARD */
.job-card {
  border: 2px solid #eee;
  border-radius: 5px;
  transition: 0.3s;
}

.job-card:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

/* TOP BOX */
.job-top {
  display: flex;
  align-items: center;
  background: #f3f4f6;
  padding: 12px;
  border-radius: 8px;
}

.job-icon {
  width: 40px;
  height: 40px;
  background: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  font-size: 18px;
}

/* DETAILS */
.job-details {
  margin-top: 15px;
}

.job-details p {
  margin: 4px 0;
  font-size: 14px;
  color: #555;
}

/* TAGS */
.tags {
  margin-top: 10px;
  display: flex;
  gap: 8px;
}

.tag {
  padding: 4px 10px;
  font-size: 12px;
  border-radius: 6px;
}

.tag.pink {
  background: #ffe4ec;
  color: #ff4d79;
}

.tag.blue {
  background: #e6f0ff;
  color: #1677ff;
}

/* PROGRESS */
.progress-custom {
  height: 6px;
  margin-top: 10px;
  background: #eee;
}

.progress-custom .progress-bar {
  background: orange;
}

small {
  font-size: 12px;
  color: #777;
}
          `}
      </style>
    </div>
  );
};

export default JobGrid;
